const $ = require('jquery')
window.$ = $
window.VERSION = process.env.VUE_APP_VERSION

import Vue from 'vue'

import 'latest-createjs'
import 'baye'
import App from './App.vue'
import router from './router'
import store from './store'
import './permission' // permission control

import VueUwp from 'vue-uwp'
import VueNumericInput from 'vue-numeric-input'
import './components/index'

Vue.use(VueNumericInput)
Vue.use(VueUwp)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
